import * as ACTION_TYPES from '../types';

let initialState = {
  projectList: [],
  project: {},
  loading: false,
  error: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_PROJECTS:
      return { ...state, projectList: action.data };
    case ACTION_TYPES.PROJECT_REQUEST:
      return { ...state, loading: true };
    case ACTION_TYPES.PROJECT_SUCCESS:
      return { ...state, loading: false, error: false };
    case ACTION_TYPES.PROJECT_FAILED:
      return { ...state, loading: false, error: true };
    case ACTION_TYPES.RESET_PROJECTS:
      return { ...state, projectList: [] };
    case ACTION_TYPES.GET_PROJECTS_BY_ID:
      return { ...state, project: action.data }
    default:
      return state;
  }
};